import { Navigate, Outlet } from 'react-router-dom';

import { useAuthStore } from '@/store/authStore';

import { ROUTES } from './routes';

export const ProtectedRoute = (): JSX.Element => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Outlet /> : <Navigate to={ROUTES.LOGIN} replace />;
};
